export class XlsxLazyLoader {
    public async loadModule(): Promise<any> {
        return await import(/* webpackChunkName: "xlsx" */ "xlsx");
    }
}
